import { useState, useCallback } from "react";
import { format, isToday } from "date-fns";
import { supabase } from "@/integrations/supabase/client";

const BUSINESS_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00",
];

export const useCalendarAvailability = () => {
  const [availableSlots, setAvailableSlots] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchAvailability = useCallback(async (date: Date) => {
    setLoading(true);

    try {
      const dateStr = format(date, "yyyy-MM-dd");
      const { data, error } = await supabase.functions.invoke("check-calendar-availability", {
        body: { date: dateStr },
      });

      if (!error && data?.availableSlots) {
        let slots = data.availableSlots as string[];
        // Filter out past times if today
        if (isToday(date)) {
          const now = new Date();
          const currentMinutes = now.getHours() * 60 + now.getMinutes();
          slots = slots.filter((slot: string) => {
            const [h, m] = slot.split(":").map(Number);
            return h * 60 + m > currentMinutes + 30;
          });
        }
        setAvailableSlots(slots);
      } else {
        // Fallback to all business slots
        let slots = [...BUSINESS_SLOTS];
        if (isToday(date)) {
          const now = new Date();
          const currentMinutes = now.getHours() * 60 + now.getMinutes();
          slots = slots.filter((slot) => {
            const [h, m] = slot.split(":").map(Number);
            return h * 60 + m > currentMinutes + 30;
          });
        }
        setAvailableSlots(slots);
      }
    } catch (err) {
      console.warn("[useCalendarAvailability] Error, falling back to all slots:", err);
      let slots = [...BUSINESS_SLOTS];
      if (isToday(date)) {
        const now = new Date();
        const currentMinutes = now.getHours() * 60 + now.getMinutes();
        slots = slots.filter((slot) => {
          const [h, m] = slot.split(":").map(Number);
          return h * 60 + m > currentMinutes + 30;
        });
      }
      setAvailableSlots(slots);
    } finally {
      setLoading(false);
    }
  }, []);

  return { availableSlots, loading, error: null, fetchAvailability };
};
